import { RefreshOutlined } from "@material-ui/icons";
import { DownloadOutlined } from "@mui/icons-material";
import { Button, Checkbox, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { useState } from "react";
import FicheEvaluationForm from "./FicheEvaluationForm";
import FicheEvaluationTable from "./FicheEvaluationTable";

const INIT_FICHE ={
  ID_FICHE_EVALUATION: 0,
  LIBELE_FICHE: "",
  ID_POSTE: 0,
  ACTIVE: "1",
}
const FicheEvaluationListFiltre = ({
  handleOpenFormDialog,
  handleCloseFormDialog,
  openForm,
}) => {
  const [filtre, setFiltre] = useState({
    critere: null,
    mot_cle: "",
    refresh: 0,
    afficher_tout_poste: true,
  });

  const [form_open, setFormOpen] = useState(false);
  const [activeKpiParentFilter, setActiveKpiParentFilter] = useState(null);
  
  const [excelExport, declenceExportToExcel] = useState(0);

  const downloadExcel = () => {
    declenceExportToExcel(excelExport + 1);
  };

  const handleOpenDialogForm = () => {
    handleOpenFormDialog();
  };

  const handleCloseDialogForm = () => {
    handleCloseFormDialog();
  };

  const handleRefreshData = () => {
    setFiltre({ ...filtre, refresh: filtre.refresh + 1 });
  };

  const handleResetFiltre = () => {
    setFiltre((current) => ({
      critere: null,
      mot_cle: "",
      afficher_tout_poste: true,
      refresh: current.refresh + 1,
    }));
  };

  const handlechangeFiltre = (evt) => {
    const { name, value } = evt.target;
    setFiltre({ ...filtre, [name]: value });
  };

  const handleCloseFormDIalog = () => {
    setFormOpen(false);
    handleRefreshData();
  };

  return (
    <Grid display={"flex"} flexDirection={"column"} minHeight={"720px"}>
      <Grid>
        
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {/* <Button
          variant="contained"
          color="error"
          onClick={handleCreatenewFiche}
        >
          CREER
        </Button> */}
        <FormGroup onChange={e=>setFiltre({...filtre,afficher_tout_poste:e.target.checked })}>
           <FormControlLabel control={<Checkbox checked={filtre.afficher_tout_poste} />} label="Afficher tous les postes" />
        </FormGroup>
        <TextField
          sx={{ width: 400 }}
          size="small"
          value={filtre.mot_cle}
          placeholder="Mot clé"
          name="mot_cle"
          onChange={handlechangeFiltre}
          className="filtre_list"
          InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <GridSearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
        />
        <IconButton
          color="primary"
          variant="outlined"
          className="filtre_list"
          onClick={handleRefreshData}
        >
          <RefreshOutlined />
        </IconButton>
        {/* <IconButton
          color="primary"
          disabled={!activeKpiParentFilter}
          variant="outlined"
          className="filtre_list"
          onClick={handleResetFiltre}
        >
          <FilterAltOffIcon /> 
        </IconButton> */}
        <Button
          variant="outlined"
          className="filtre_list"
          onClick={downloadExcel}
          startIcon={<DownloadOutlined />}
        >
          Excel export
        </Button>
      </Grid>
      <Grid flexGrow={1} mt={3}>
        <FicheEvaluationForm
          ficheEvaluation={INIT_FICHE}
          handleClose={handleCloseFormDIalog}
          isOpen={form_open}
        />
        <FicheEvaluationTable
          excelExport={excelExport}
          handleOpenDialog={handleOpenDialogForm}
          onCloseForm={handleCloseDialogForm}
          openForm={openForm}
          filtre={filtre}
          onResetFilters={handleResetFiltre}
          listFiltersActive={filtre.mot_cle !== ""}
          setActiveKpiParentFilter={setActiveKpiParentFilter}
        />
      </Grid>
    </Grid>
  );
};

export default FicheEvaluationListFiltre;
